import type { AppEnv } from '@hc-frontend/core-context';
import { getClientApplicationConfig } from '@hc-frontend/core-context';

const stmHealthcareComLinkRegex =
  /^(www\.)?stm\.((stg|qa|dev)\.)?healthcare\.com/;

export function isStmHealthcareComLink(url: URL) {
  return stmHealthcareComLinkRegex.test(url.hostname);
}

const hostnameMap: Record<AppEnv, string> = {
  local: 'stm.qa.healthcare.com',
  dev: 'stm.stg.healthcare.com',
  qa: 'stm.qa.healthcare.com',
  stg: 'stm.qa.healthcare.com',
  prd: 'stm.healthcare.com',
};

export function checkStmHealthcareComLink(url: URL): string {
  const config = getClientApplicationConfig();
  // eslint-disable-next-line no-param-reassign
  url.hostname = hostnameMap[config.core.appEnvironment];
  return decodeURIComponent(url.href);
}
